var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icons-mobile-group",style:({ justifyContent: 'flex-end' })},[_c('div',{staticClass:"icon-mobile-group",on:{"click":_vm.clickedSearchIconHandler}},[_c('div',{staticClass:"icon-mobile-item"},[_c('MagnifyIcon')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }